export const ConsignmentTableHeaders=[
    {
        Header:'Style',
        accessor:'style'
    },
    
    {
        Header:'Company',
        accessor:'company'
    },
    {
        Header:'Color',
        accessor:'color'
    },
    {
        Header:'US Size',
        accessor:'USSize'
    },
    {
        Header:'EUR Size',
        accessor:'EURSize'
    },
    {
        Header:'Quantity',
        accessor:'quantity'
    },
    {
        Header:'Cost',
        accessor:'cost'
    },
    {
        Header:'Price',
        accessor:'price'
    },
    {
        Header:'Description',
        accessor:'description'
    }
]
export const SendBackTableHeaders=[
    {
        Header:'Style',
        accessor:'style'
    },
    
    {
        Header:'Company',
        accessor:'company'
    },
    {
        Header:'Color',
        accessor:'color'
    },
    {
        Header:'US Size',
        accessor:'USSize'
    },
    {
        Header:'EUR Size',
        accessor:'EURSize'
    },
    {
        Header:'Quantity',
        accessor:'quantity'
    },
    {
        Header:'Cost',
        accessor:'cost'
    },
    {
        Header:'Price',
        accessor:'price'
    },
    {
        Header:'Issue Date',
        accessor:'issueDate'
    }
]

export const ConsignmentMobileTableHeaders=[
    {
        Header:'Style',
        accessor:'style'
    },
    
    {
        Header:'Company',
        accessor:'company'
    },
    {
        Header:'Color',
        accessor:'color'
    },
    {
        Header:'US Size',
        accessor:'USSize'
    },

    {
        Header:'Cost',
        accessor:'cost'
    },
    {
        Header:'Description',
        accessor:'description'
    }
]

export const SendBackMobileTableHeaders=[
    {
        Header:'Style',
        accessor:'style'
    },
    
    {
        Header:'Company',
        accessor:'company'
    },
    {
        Header:'Color',
        accessor:'color'
    },
    {
        Header:'US Size',
        accessor:'USSize'
    },
    {
        Header:'Price',
        accessor:'price'
    }
]